import axios from "../http_v2";

export default {
  list(params) {
    return axios.get("cmsservice/customerWall/page", params);
  },
  add(params) {
    return axios.post("cmsservice/customerWall/add", params);
  },
  update(params) {
    return axios.post("cmsservice/customerWall/update", params);
  },
  delete(params) {
    return axios.post("cmsservice/customerWall/delete", params);
  },
  info(id) {
    return axios.get("cmsservice/customerWall/info/" + id, {});
  },
  type: {
    tree(params) {
      return axios.get("cmsservice/customerWallSort/tree", params);
    },
    add(params) {
      return axios.post("cmsservice/customerWallSort/add", params);
    },
    update(params) {
      return axios.put("cmsservice/customerWallSort/update", params);
    },
    delete(id) {
      return axios.delete("cmsservice/customerWallSort/del/" + id, {});
    }
  }
};
